import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  staging: true,
  development: false,
  apiUrl: 'https://stage-api.insightstobehavior.net/api',
  lmsUrl: 'https://stage-moodle.insightstobehavior.net',
  label: 'STAGE',
  notificatioHubUrl: 'https://stage-api.insightstobehavior.net/notificationHub',
};
